<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>


    <!-- 비상대응절차 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 비상대응절차</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">유형</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.유형 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.유형" :max="100"/>
        </div>
        <div>
          <div class="form-title">절차/시나리오명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.절차_시나리오명 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.절차_시나리오명" :max="100"/>
        </div>
        <div>
          <div class="form-title">관리부서</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.관리부서 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.관리부서" :max="100"/>
        </div>

        <div>
          <div class="form-title">대응절차서/시나리오</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.대응절차서 }}</p>
          <file-uploader v-else v-model="form.대응절차서"/>
        </div>

      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";

export default {
  components: {
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        유형: "",
        절차_시나리오명: "",
        관리부서: "",
        대응절차서: {},
        대응시나리오: {},
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
